import {register} from '@shopify/theme-sections';

import renderProductCard from '../components/product-card-template';
import {constructLocalisedProductLink} from '../utils/tagalys';

const selectors = {
  widget: '[data-widget="recenly-viewed-products"]',
};

const sectionType = 'tagalys-recently-viewed';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const settings = JSON.parse(this.container.dataset.settings || '{}');
      const excludedProductIds = settings.excludedProductIds || [];

      window.Tagalys.UIWidgets.RecentlyViewedProducts.init(selectors.widget, {
        excludedProductIds,
        templates: {
          widget: {
            labels: {
              heading: settings.title,
            },
            options: {
              limit: 8,
              displayFormat: 'carousel',
              includeTagalysCSS: false,
              carouselOptions: {
                perPage: {
                  300: 2,
                  768: 3,
                  1280: 4,
                },
              },
            },
            render: function (html, args) {
              const props = args.props;
              const helpers = props.helpers;
              const products = helpers.getProducts();

              if (props.loading === false) {
                if (products.length === 0) {
                  return null;
                }
                return html`
                  <div class="container">
                    <${args.templates.header} />
                    <${args.templates.productList} />
                  </div>
                `;
              }
            },
          },
          header: {
            render: function (html, args) {
              return html` <h2 class="product-recently-viewed__heading">${args.labels.heading}</h2> `;
            },
          },
          products: {
            render: function (html, args) {
              const props = args.props;
              const products = props.helpers.getProducts();

              return html`
                <div class="products products-carousel">
                  ${products.map((product, index) => {
                    return html` <${args.templates.product} key=${index} product=${product} /> `;
                  })}
                </div>
              `;
            },
            callbacks: {
              afterEveryRender: function () {
                document.dispatchEvent(new CustomEvent('results-grid:loaded'));
              },
            },
          },
          product: {
            options: {
              // Generate the product page URL using the product object
              productPageUrl(product) {
                return constructLocalisedProductLink(product);
              },
            },
            render: function (html, args) {
              const {props} = args;
              const {product, helpers} = props;

              return html`<div dangerouslySetInnerHTML=${{__html: renderProductCard(product, helpers)}} />`;
            },
          },
          carouselActions: {
            render: function (html, args) {
              const props = args.props;

              return html`
                <button
                  class="products-carousel__btn products-carousel__prev"
                  disabled=${props.helpers.carousel.isFirstSlide()}
                  onClick=${props.helpers.carousel.goLeft}
                >
                  <svg
                    aria-label="Chevron left icon"
                    class="icon icon-chevron-left"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="m14 18-6-6 6-6"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="square"
                      vector-effect="non-scaling-stroke"
                    />
                  </svg>
                </button>

                <button
                  class="products-carousel__btn products-carousel__next"
                  disabled=${props.helpers.carousel.isLastSlide()}
                  onClick=${props.helpers.carousel.goRight}
                >
                  <svg
                    aria-label="Chevron right icon"
                    class="icon icon-chevron-right"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="m10 18 6-6-6-6"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="square"
                      vector-effect="non-scaling-stroke"
                    />
                  </svg>
                </button>
              `;
            },
          },
        },
        callbacks: {
          onSuccessfulAPICall: async (response) => {
            const staticTranslations = {};
            const translatedResponse = await TagalysMarketTranslations.translate(response, staticTranslations);
            return translatedResponse;
          },
        },
      });
    },

    onBlockSelect(event) {
      // Only run in the admin theme customizer
      if (!Shopify.designMode) {
        return;
      }
    },

    onDeselect() {
      // Only run in the admin theme customizer
      if (!Shopify.designMode) {
        return;
      }
    },
  });
